export type Role = "super_admin" | "admin" | "user" | "user_read_only";
export type PermissionType = "read" | "write" | "invite" | "manage_admins";
export const roleDisplayMap: Record<Role, string> = {
  super_admin: "Super Admin",
  admin: "Admin",
  user: "User",
  user_read_only: "Read Only",
};

export const roles: Role[] = ["super_admin", "admin", "user", "user_read_only"];
